import React from 'react';
import List from '@material-ui/core/List';

const FolderList = ({ children, ...props }) => <List {...props}>{children}</List>;

export default FolderList;
